var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block__tile-wrapper"},_vm._l((_vm.data),function(item,index){return _c('NeoCompareBlockTile',{key:`neo-compare-block-${index}`,attrs:{"item":item,"height":_vm.maxHeight},on:{"computed-height":_vm.equalHeight}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }